import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ISSUES } from "@/data/content";
import { Marked, HandTag, ArrowDraw, Asterisk } from "@/components/campaign/HandDrawn";

const Issues = () => {
  return (
    <main data-testid="issues-page">
      <section className="section border-b border-ink/25 relative">
        <div className="container-x grid gap-12 md:grid-cols-12 items-end">
          <div className="md:col-span-8">
            <p className="overline inline-flex items-center gap-2">
              <Asterisk className="h-4 w-4" /> The platform
            </p>
            <h1 className="mt-4 font-editorial font-semibold text-5xl md:text-7xl tracking-tight leading-[0.95] text-ink">
              Where I stand — <br />
              and what I&apos;ll{" "}
              <Marked>fight</Marked> for{" "}
              <Marked>in Concord</Marked>.
            </h1>
          </div>
          <div className="md:col-span-4">
            <p className="text-ink/75 leading-relaxed text-lg">
              These positions weren&apos;t written behind closed doors. They were shaped by canvasses,
              town halls, and years of organizing alongside Manchester residents.
            </p>
          </div>
        </div>
      </section>

      <section className="section bg-parchment" data-testid="issues-grid-section">
        <div className="container-x">
          <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            {ISSUES.map((issue) => (
              <article
                key={issue.title}
                className="bg-white/5 border border-rule rounded-2xl p-8 transition-colors duration-300 hover:border-terracotta/60"
                data-testid={`issue-${issue.pillar.toLowerCase()}`}
              >
                <p className="overline">{issue.pillar}</p>
                <h2 className="mt-4 font-editorial font-semibold text-2xl text-ink leading-tight">
                  {issue.title}
                </h2>
                <p className="mt-4 text-ink/80 leading-relaxed">{issue.summary}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-ink text-cream section relative overflow-hidden" data-testid="issues-cta-section">
        <div className="container-x grid gap-10 md:grid-cols-12 items-center">
          <div className="md:col-span-7">
            <p className="overline !text-terracotta inline-flex items-center gap-2">
              <Asterisk className="h-4 w-4" /> Have ideas?
            </p>
            <h2 className="mt-4 font-editorial font-semibold text-4xl md:text-6xl leading-[0.95]">
              This platform <Marked color="#F58A3F">grows</Marked><br />
              with the campaign.
            </h2>
            <p className="mt-8 text-cream/80 max-w-xl text-lg leading-relaxed">
              If something matters to your block and it&apos;s not on this list,{" "}
              <span className="italic font-semibold text-terracotta text-base">tell me</span>. The whole
              point is to listen.
            </p>
          </div>
          <div className="md:col-span-5 flex flex-wrap gap-4 md:justify-end">
            <Link to="/contact" className="btn-primary" data-testid="issues-cta-contact">
              Send a note <ArrowUpRight size={18} />
            </Link>
            <Link
              to="/volunteer"
              className="btn-ghost !border-cream !text-cream hover:!bg-cream hover:!text-graphite"
              data-testid="issues-cta-volunteer"
            >
              Volunteer
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Issues;
